import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonBlock = ({ className }) => (_jsx("div", { className: `skeleton-shimmer shimmer-card rounded-[26px] ${className}` }));
